import {Row} from 'antd';
import React from 'react';
import {RiseLoader} from 'react-spinners';
import {PRIMARY_200} from '@app/style/GlobalColors';

const LoadingSpinnerRise = () => {

  return (
    <Row className={'flex justify-center items-center w-full h-full fixed z-50 bottom-0 left-0 backdrop-blur-2xl'}>
      <RiseLoader size={80} margin={8} color={PRIMARY_200} />
    </Row>
  );
};

export default LoadingSpinnerRise;
